// «Текст решения» («Текст определения») под пунктом ответа по праву со ссылкой на решение суда Дагестана: о чём дело,
// что суд решил или определил, весь текст из базы Правосвода и ссылка на СудАкт.ру (GET /api/courts/<id>). Загружается
// только при раскрытии; вид акта — по подписи источника.
import { useState } from "react";
import { getJson } from "../api";

type CourtDecision = {
  id: string; label: string; title: string; court: string; kind: string; category: string; subject: string;
  ruling: string; resolution: string; text: string; url: string; checked: string;
};

export function isCourtDecision(sourceId: string | undefined): boolean {
  return !!sourceId && sourceId.startsWith("sd:");
}

export function CourtDecisionText({ id, label }: { id: string; label: string }) {
  const ruling = /^(Апелляционное |Кассационное )?определение/i.test(label);
  const [decision, setDecision] = useState<CourtDecision | null>(null);
  const [error, setError] = useState("");
  function load(open: boolean) {
    if (!open || decision || error) return;
    getJson<CourtDecision>(`/api/courts/${encodeURIComponent(id)}`).then(setDecision)
      .catch((failure) => setError((failure as Error).message));
  }
  return (
    <details className="assistant-article" onToggle={(event) => load((event.currentTarget as HTMLDetailsElement).open)}>
      <summary>{ruling ? "Текст определения" : "Текст решения"}</summary>
      {error ? <p className="msg-error">{error}</p> : !decision ? <p className="msg-hint">Загружаю…</p> : (
        <>
          <p className="decision-subject">{[decision.court, decision.category].filter(Boolean).join(", ")}</p>
          {decision.subject ? <p>{decision.subject}</p> : null}
          {decision.ruling ? (
            <>
              <p className="msg-hint">{decision.ruling.charAt(0).toUpperCase() + decision.ruling.slice(1)}</p>
              <blockquote>{decision.resolution}</blockquote>
            </>
          ) : null}
          <details className="decision-full">
            <summary>{ruling ? "Весь текст определения" : "Весь текст решения"}</summary>
            <blockquote>{decision.text}</blockquote>
          </details>
          <p className="msg-hint">
            {decision.title}. Текст скачан {decision.checked}.{" "}
            <a href={decision.url} target="_blank" rel="noreferrer">Решение на СудАкт.ру</a>
          </p>
        </>
      )}
    </details>
  );
}
